import { withStoreRequiredForReadOnlyEditor } from './core/withStoreRequiredForReadOnlyEditor';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { compose } from '@doltech/utils/lib/compose';
import { BlogEditorReadOnly } from './BlogEditorReadOnlyV2';
import { useDoExerciseProgressContext } from './shared-components/Exercise/DoExerciseProgressContext';
import { useFileUploadStore } from '../DolEditor/elements/BlogEditor/model/file-upload-model';
import styled from 'styled-components';
import { colorsV2 } from '../colors-v2';
import { sharedFontStyles } from '../DolEditor/font-styles';
import { tableStyle } from '../DolEditor/elements/table-blog/components/readonly/styles/blog';
import { blockQuoteStyle } from './plugins/Quote/styles/blog';

const ReadOnlyMain = styled(BlogEditorReadOnly)`
  ${sharedFontStyles}
  ${tableStyle}
  ${blockQuoteStyle}

  p,
  h1,
  h2,
  h3 {
    margin-bottom: 0;
  }

  a {
    cursor: pointer;
    color: ${colorsV2.blue100};
    text-decoration-line: underline;

    &:hover {
      color: ${colorsV2.blue60};
      text-decoration-line: underline;
    }
  }

  > * + * {
    margin-top: 24px;
  }

  > * + .admin-table-container {
    margin-bottom: 40px;
  }

  > * + h1 {
    margin-top: 16px;
  }
  > * + h2 {
    margin-top: 12px;
  }
  > * + h3 {
    margin-top: 18px;
  }

  > p + p {
    margin-top: 32px;
  }

  // bullet point
  ul,
  ol {
    li {
      &:not(:last-child) {
        margin-bottom: 8px;
      }

      p {
        margin-bottom: 0;

        + ul,
        ol {
          margin-top: 4px;
        }
      }
    }
  }
`;

const BlogEditorReadOnlyWithStylesBase = (props: any) => {
  const { seoData, pageData } = props;
  const { ...rest } = props;
  const doExerciseContext = useDoExerciseProgressContext();
  const fileUploadStore = useFileUploadStore();
  React.useEffect(() => {
    if (seoData && !doExerciseContext.pageId) {
      doExerciseContext.setPageId(seoData.id);
    }
    if (Boolean(fileUploadStore?.initialed) === false) {
      fileUploadStore?.initMedia(pageData?.detailData?.mediaInfos);
    }
  }, [doExerciseContext, seoData, fileUploadStore, pageData?.detailData?.mediaInfos]);
  return <ReadOnlyMain {...rest} />;
};

export const BlogEditorReadOnlyWithStyles = compose(
  withStoreRequiredForReadOnlyEditor({
    haveDoTestExercise: true,
  }),
  observer
)(BlogEditorReadOnlyWithStylesBase);

export const BlogEditorReadOnlyWithStylesWithoutStore = observer(BlogEditorReadOnlyWithStylesBase);
